import classes from './QuestionCard.module.css';

const QuestionCard = ({ question, className }) => {
    return(
        <div className={`${classes.questionContainer} ${className}`}>
         {question}
        </div>
    )
}

export default QuestionCard;
